/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSword = createReactComponent("sword", "IconSword", [
  ["path", { d: "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z", key: "svg-0" }],
  ["path", { d: "M6.5 11.5l6 6", key: "svg-1" }]
]);

export { IconSword as default };
//# sourceMappingURL=IconSword.js.map
